import { FC } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { getFlightSegments, groupSegmentsByDirection } from 'entities/tour/libs'
import { selectionStore } from 'entities/tour/models'

import { Flight, RawTourFlight } from 'shared/api/tours/flights/model'
import { Button } from 'shared/ui/button'

import { FlightSegment } from './components'
import s from './styles.module.scss'

interface FlightCardProps {
  flight: Flight
  rawFlight: RawTourFlight
}

export const FlightCard: FC<FlightCardProps> = ({ flight, rawFlight }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const transports = flight.transport

  if (!transports || transports.length === 0) {
    return null
  }

  const segmentsByDirection = groupSegmentsByDirection(transports)

  const flightSegments = getFlightSegments(segmentsByDirection, t)

  const handleViewDetails = () => {
    selectionStore.setSelectedFlight(rawFlight)
    navigate(RoutingPaths.tours.flightDetails.path())
  }

  return (
    <div className={s.flightCard}>
      <div className={s.segments}>
        {flightSegments.map((segment) => (
          <FlightSegment
            key={segment.key}
            data={segment.data}
          />
        ))}
      </div>

      <Button
        className="bold-16"
        variant="solidBlue"
        onClick={handleViewDetails}
      >
        {t('more')}
      </Button>
    </div>
  )
}
